<template>
  <t-upload v-slot="{ on }" :accept="acceptedFileTypes.join(', ')" @input="onSelectFile">
    <slot
      v-bind="{
        on,
        isCompressing,
        isCompressed,
        isTransformFile,
        originFile,
        transformFile,
        onSelectFile,
        compareImage,
        reset,
      }"
    ></slot>
  </t-upload>
</template>

<script>
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
module.exports = void 0;
var _messageBox = _interopRequireDefault(require("element-ui/packages/message-box"));
var _pintura = require("@vt7/pintura");
var _vue = require("vue");
var _tUpload = _interopRequireDefault(require("@thinkvn/ui/components/upload/t-upload.vue"));
var _utils = require("./utils");
var _imageCompare = require("./image-compare");
require("element-ui/lib/theme-chalk/message-box.css");
require("@vt7/pintura/pintura.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = (0, _vue.defineComponent)({
  components: {
    TUpload: _tUpload.default
  },
  props: {
    allowFileTypeValidation: {
      type: Boolean,
      default: false
    },
    allowConvertFileType: {
      type: Boolean,
      default: false
    },
    acceptedFileTypes: {
      type: Array,
      default: () => ["image/*"]
    },
    forceType: {
      type: String,
      default: ""
    },
    allowFileDimensionValidation: {
      type: Boolean,
      default: false
    },
    allowResizeFile: {
      type: Boolean,
      default: false
    },
    targetSize: {
      type: Object,
      default: void 0
    },
    minSize: {
      type: Object,
      default: void 0
    },
    fit: {
      type: String,
      default: "contain"
    },
    allowFileSize: {
      type: Boolean,
      default: false
    },
    allowCompress: {
      type: Boolean,
      default: false
    },
    allowCompareImage: {
      type: Boolean,
      default: false
    },
    maxFileSize: {
      type: Number,
      default: 400 * 1024
    },
    shortPixelApiKeys: {
      type: Array,
      default: () => []
    }
  },
  emits: ["crop", "convert", "compress:error", "compress:success", "change"],
  setup(props, {
    emit
  }) {
    const isCompressing = (0, _vue.ref)(false);
    const isCompressed = (0, _vue.ref)(false);
    const isTransformFile = (0, _vue.ref)(false);
    const originFile = (0, _vue.ref)();
    const transformFile = (0, _vue.ref)();
    const key = (0, _vue.ref)("");
    const {
      allowFileTypeValidation,
      allowConvertFileType,
      acceptedFileTypes,
      allowFileDimensionValidation,
      allowResizeFile,
      targetSize,
      minSize,
      forceType,
      allowFileSize,
      allowCompress,
      maxFileSize
    } = (0, _vue.toRefs)(props);
    const toFile = (data, filename) => {
      const mimeType = forceType.value || (0, _utils.getExtensionFromFilename)(filename);
      const newFileName = `${(0, _utils.getNameFromFilename)(filename)}.${mimeType}`;
      return new File([data], newFileName, {
        type: (0, _utils.guesstimateMimeType)(mimeType)
      });
    };
    const reset = () => {
      isCompressing.value = false;
      isCompressed.value = false;
      isTransformFile.value = false;
      originFile.value = void 0;
      transformFile.value = void 0;
    };
    const onSelectFile = async files => {
      const file = files[0];
      try {
        reset();
        originFile.value = file;
        transformFile.value = file;
        await handleValidateDimension(transformFile.value);
        await handleValidateFileType(transformFile.value);
        await handleValidateFileSize(transformFile.value);
        console.log("final size: ", await (0, _utils.getDimensionFile)(transformFile.value));
        emit("change", transformFile.value);
      } catch (e) {
        console.log("e", e);
      }
    };
    const handleValidateDimension = async file => {
      const data = await (0, _pintura.processDefaultImage)(file, {
        imageWriter: (0, _pintura.createDefaultImageWriter)({
          mimeType: forceType.value && (0, _utils.guesstimateMimeType)(forceType.value),
          targetSize: {
            ...targetSize.value,
            fit: props.fit,
            upscale: false
          }
        })
      });
      const resizedSize = await (0, _utils.getDimensionFile)(data.dest);
      return (0, _utils.validateDimension)(file, {
        allowFileDimensionValidation: allowFileDimensionValidation.value,
        allowResizeFile: allowResizeFile.value,
        targetSize: targetSize.value,
        minSize: minSize.value || targetSize.value,
        resizedSize,
        callbackResize: () => {
          isTransformFile.value = true;
          try {
            transformFile.value = data.dest;
            emit("crop", transformFile.value);
          } catch (e) {}
        }
      });
    };
    const handleValidateFileType = file => {
      return (0, _utils.validateFileType)(file, {
        allowFileTypeValidation: allowFileTypeValidation.value,
        allowConvertFileType: allowConvertFileType.value,
        acceptedFileTypes: acceptedFileTypes.value,
        callbackConvertFileType: async () => {
          const newFile = await (0, _utils.onConvertFileType)(file, forceType.value || "jpg");
          isTransformFile.value = true;
          transformFile.value = toFile(newFile, file.name);
          emit("convert", file);
        }
      });
    };
    const handleValidateFileSize = file => {
      const compressError = () => {
        isCompressing.value = false;
        isTransformFile.value = false;
        emit("compress:error");
        throw new Error("compress:error");
      };
      return (0, _utils.validateFileSize)(file, {
        allowFileSize: allowFileSize.value,
        allowCompress: allowCompress.value,
        maxFileSize: maxFileSize.value,
        callbackCompress: async () => {
          isCompressing.value = true;
          isTransformFile.value = true;
          originFile.value = file;
          const blob = await (0, _utils.fileUpload)(file, {
            keys: props.shortPixelApiKeys
          });
          if (blob === "NOT_FOUND_KEY") {
            _messageBox.default.alert("Kh\xF4ng th\u1EC3 n\xE9n \u1EA3nh do key h\u1EBFt h\u1EA1n. Vui l\xF2ng b\xE1o l\u1EA1i cho b\u1ED9 ph\u1EADn k\u1EF9 thu\u1EADt \u0111\u1EC3 \u0111\u01B0\u1EE3c h\u1ED7 tr\u1EE3.", "C\u1EA3nh b\xE1o", {
              confirmButtonText: "OK"
            });
            return compressError();
          }
          if (!blob) {
            _messageBox.default.alert("N\xE9n \u1EA3nh kh\xF4ng th\xE0nh c\xF4ng", "C\u1EA3nh b\xE1o", {
              confirmButtonText: "OK"
            });
            return compressError();
          }
          const newFile = toFile(blob, file.name);
          if (newFile.size <= maxFileSize.value) {
            transformFile.value = newFile;
            isCompressing.value = false;
            isCompressed.value = true;
            emit("compress:success", newFile);
            if (props.allowCompareImage) {
              await compareImage();
            }
          } else {
            _messageBox.default.alert(`Kh\xF4ng th\u1EC3 n\xE9n \u1EA3nh xu\u1ED1ng ${(0, _utils.bytesToSize)(maxFileSize.value)}`, "C\u1EA3nh b\xE1o", {
              confirmButtonText: "OK"
            });
            return compressError();
          }
        }
      });
    };
    const compareImage = async () => {
      const {
        width,
        height
      } = await (0, _utils.getDimensionFile)(originFile.value);
      (0, _imageCompare.createCompareImage)({
        leftImage: URL.createObjectURL(originFile.value),
        leftImageSize: originFile.value?.size,
        rightImage: URL.createObjectURL(transformFile.value),
        rightImageSize: transformFile.value?.size,
        width,
        height
      });
    };
    return {
      isCompressing,
      isCompressed,
      isTransformFile,
      originFile,
      transformFile,
      onSelectFile,
      compareImage,
      reset,
      key
    };
  }
});
module.exports = _default;</script>
